var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add_box"},[_c('card-number',{attrs:{"come":"add","mustImg":_vm.mustImg},on:{"inputChange":_vm.inputChange}}),_c('common-footer',{attrs:{"text":"添加","canClick":_vm.canClick},on:{"btnClick":_vm.btnClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }